/* eslint-disable react/jsx-props-no-spreading */
import { Field, Form as FinalForm } from "react-final-form";
import Form from "react-bootstrap/Form";
import { purchaseOrderItemPriorityEditSchema } from "../_types";
import { validateForm } from "../_helpers";
import { updatePurchaseOrderItemPriority } from "../_gateway/vendorGateway";

export interface PurchaseOrderItemPriorityFieldProps {
  purchaseOrderItemId: number;
  priority: number | null;
  canChangePriority: boolean;
}

export interface PurchaseOrderItemPriorityProblems {
  errors: {
    Priority: string[];
  };
}

export function PurchaseOrderItemPriorityField({
  purchaseOrderItemId,
  priority,
  canChangePriority,
}: PurchaseOrderItemPriorityFieldProps) {
  const handleOnSubmit = async (values: Record<string, any>) => {
    const parsedPriority = purchaseOrderItemPriorityEditSchema.parse(values);

    await updatePurchaseOrderItemPriority(
      purchaseOrderItemId,
      parsedPriority.priority ?? null
    );

    // Need to handle server errors somehow
  };

  return canChangePriority ? (
    <FinalForm
      initialValues={{ priority }}
      onSubmit={handleOnSubmit}
      subscription={{ submitting: true }}
      validate={(values: Record<string, any>) =>
        validateForm(values, purchaseOrderItemPriorityEditSchema)
      }
      render={({ handleSubmit, form }) => (
        <Form onSubmit={handleSubmit}>
          <Field // At some point, this may be a useful component
            name="priority"
            render={({ input, meta }) => (
              <>
                <Form.Control
                  type="number"
                  {...input}
                  onBlur={() => form.submit()}
                  isInvalid={meta.error}
                />
                <Form.Control.Feedback type="invalid">
                  {meta.error}
                </Form.Control.Feedback>
              </>
            )}
          />
        </Form>
      )}
    />
  ) : (
    <div>{priority}</div>
  );
}
